// extracted by mini-css-extract-plugin
module.exports = {"logo":"_64a233"};